import {useQuery} from '@tanstack/react-query'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import CustomApi from './use-custom-api'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'

const useLoyaltyCalloutsConfigs = (isRegistered, isYR) => {
    const {getTokenWhenReady} = useAccessToken()
    const customapi = new CustomApi()
    const api = useCommerceApi()
    const {proxy} = api.shopperExperience.clientConfig

    const fetchLoyaltyCalloutsConfigs = async (isRegistered) => {
        const token = await getTokenWhenReady()
        const apiName = 'loyalty-callouts'
        const endpointPath = '/'
        const parameters = {
            c_isRegistered: isRegistered,
            c_isYR: isYR
        }
        const response = await customapi.get(token, apiName, endpointPath, parameters, proxy)

        return response
    }

    return useQuery({
        queryKey: ['use-loyalty-callouts-configs', isRegistered],
        queryFn: () => fetchLoyaltyCalloutsConfigs(isRegistered),
        enabled: !isServer
    })
}

export default useLoyaltyCalloutsConfigs
